import React, { Component } from 'react'
import { Document, Page, setOptions } from 'react-pdf/dist/entry.webpack'
import './PdfViewer.css'
import { detect } from "detect-browser";
import { port, post } from '../../service/index'
import swal from 'sweetalert'
import Loader from '../Loader/Loader'
setOptions({
    cMapUrl: "cmaps/",
    cMapPacked: true
});

export default class PdfViewer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            numPages: null,
            page: 0,
            currentPage: 0,
            pdfBlob: null,
            loading: true
        };
    }

    componentDidMount = () => {
        console.log(this.props)
        // const { data, currentSub } = this.props.conference;
        const { url, token } = this.props
        fetch(
            url ? {
                url: `${port}/upload/${url.replace('upload', '').replace('/', '')}`,
                withCredentials: true
            } : require('../../assets/pdf/mountain.pdf'),
            {
                method: "GET",
                credentials: "include",
                headers: {
                    Authorization: token
                }
            }
        )
            .then(r => r.blob())
            .then(blob => {
                // showFile(blob);
                let newBlob = new Blob([blob], { type: "application/pdf" });
                const data = URL.createObjectURL(newBlob);
                this.setState({ pdfBlob: data })
            });

        // setTimeout(() => {
        //     this.setState({ loading: false })
        // }, 3000);

    }


    render() {
        const { numPages, page, currentPage } = this.state;
        const { url, token } = this.props
        return (

            <div className="Example__container__document">
                <Document
                    //   file={
                    //     data
                    //       ? {
                    //         url: `${server}/${data[currentSub].url.replace('upload', 'upload/')}`,
                    //         withCredentials: true
                    //       }
                    //       : require("../../assets/pdf/demo.pdf")
                    //   }

                    file={url ? {
                        url: `${port}/upload/${url.replace('upload', '').replace('/', '')}`,
                        httpHeaders: {
                            "Authorization": token
                        }
                    } : require('../../assets/pdf/mountain.pdf')}

                    onLoadSuccess={this.onDocumentLoad}
                    onLoadError={err => console.log(err)}
                    loading={<Loader />}

                >

                    <Page key={`page_${currentPage}`} pageNumber={currentPage + 1} pageIndex={currentPage} />



                </Document>
                {
                    !this.state.loading ? <React.Fragment>
                        <div className="columns">
                            <div className="column"> <div className="select-pdf btn_left">
                                <button onClick={this.handlePrevPage}>ก่อนหน้า</button>
                            </div></div>
                            <div className="column" style={{
                                display: 'flex'
                                , justifyContent: 'center'
                                , alignItems: 'center'
                                , marginTop: 10
                            }} ><p> {(currentPage + 1) + ' /' + this.state.numPages} </p></div>
                            <div className="column"> <div className="select-pdf btn_right">
                                <button onClick={this.handleNextPage}>ต่อไป</button>
                            </div></div>
                        </div>

                        <div className="level">
                            <div className="level-left" onClick={this.handleAccepted}  >
                                <a id={currentPage + 1 === this.state.numPages ? "accept-term" : "accept-term1"}>
                                    {" "}
                                    ข้าพเจ้าได้อ่านเอกสารการประชุมเรียบร้อยแล้ว{" "}
                                </a>
                            </div>
                            <div className="level-right">
                                <div id="pdf-action">
                                    {/*<img src={require('../../assets/icon/printer.png')}  alt='printer' onClick={()=>this.handlePrinter()}/>*/}
                                    <img
                                        src={require("../../assets/icon/download.png")}
                                        alt="download"
                                        onClick={this.handleDownload}
                                    />
                                    <img
                                        src={require("../../assets/icon/full-size.png")}
                                        alt="full-size"
                                        onClick={this.handleFullsize}
                                    />
                                </div>
                            </div>
                        </div>
                    </React.Fragment> : null
                }
            </div>
        )
    }


    handleNextPage = () => {

        if (this.state.currentPage < this.state.numPages - 1)
            this.setState(prevState => ({ currentPage: prevState.currentPage + 1 }))
    };

    handlePrevPage = () => {

        if (this.state.currentPage > 0) {
            this.setState(prevState => ({ currentPage: prevState.currentPage - 1 }))
        }
    };

    onDocumentLoad = ({ numPages }) => {
        // this.props.setPdfLoading(false)
        this.setState({ numPages, loading: false });
        console.log(numPages)
        // alert(numPages)
        // if (numPages) {

        // }


    };

    handleDownload = () => {
        // const browser = detect();


        // if (browser) {
        //     switch (browser.name) {
        //         case "firefox":
        //             this.openPdfInChrome();
        //             break;

        //         default:

        //             const filename = this.props.document_name ? this.props.document_name.split('.')[0] + '.pdf' : "demo.pdf";

        //             let Download = document.createElement("a");
        //             Download.href = this.state.pdfBlob;
        //             Download.download = filename
        //             document.body.appendChild(Download);
        //             Download.click();
        //             document.body.removeChild(Download);
        //     }
        // }

        window.open(port + '/downloads/' + this.props.url.replace('upload', '').replace('/', ''), '_blank')

    }

    handleFullsize = () => {
        const browser = detect();
        const filename = this.props.url ? `${port}/upload/${this.props.url.replace('upload', '').replace('/', '')}` : require('../../assets/pdf/demo.pdf')

        if (browser) {
            switch (browser.name) {
                case "safari":
                    this.openPdfInSafari();
                    break;
                default:
                    // this.openPdfInChrome();
                    // window.open(this.state.pdfBlob)
                    setTimeout(() => {
                        window.open(filename)
                    }, 300);

                    break;
            }
        }
    };

    openPdfInSafari = () => {
        const file = this.props.url ? `${port}/upload/${this.props.url.replace('upload', '').replace('/', '')}` : require('../../assets/pdf/demo.pdf')
        window.open(file);
    };

    openPdfInChrome = () => {
        window.open(this.state.pdfBlob)
    }

    handleAccepted = async () => {
        const { currentPage, numPages } = this.state
        const { doc_id, user, token } = this.props

        if (currentPage + 1 === numPages) {
            try {
                const setRead = await post('/save_read_conference', { doc_id, user }, token)
                swal('คุณได้อ่านเอกสารแล้ว', '', 'success')
            } catch (err) {
                console.log(err)
            }
        }

    }
}




// WEBPACK FOOTER //
// ./src/components/PdfViewer/PdfViewer.js